// Minimal start entry — required by TanStack Start plugin.
// Attaches Supabase bearer token to server-fn calls so requireSupabaseAuth works.
import { createStart } from "@tanstack/react-start";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
}));
